// Preserve the existing policy while the Prompt 20 choices await a reply.
// Unknown counteroffer/expiry choices gate only those new transitions.
export const offerPolicy={counteroffers:null,expiry:null,kyc:'buyer_at_acceptance',multipleAccepted:true};
